/*
 * @Description: 管理列表
 * @Author: yanzhigen@batmobi.net
 * @Date: 2018-11-08 15:23:55
 * @LastEditors: yanzhigen@batmobi.net
 * @LastEditTime: 2018-11-16 11:21:38
 */
<template>
    <div class="manage-table">
        <!-- 表格 -->
        <table class="c-body-table">
            <!-- 表格标题 -->
            <thead class="table-thead">
                <tr class="table-tr">
                    <td class="table-td-primary table-td-primary-select">
                        <div class="icon-wrap">
                            <Checkbox v-model="selectedAll" @on-change="onSelectedAll"></Checkbox>
                        </div>
                    </td>
                    <td class="table-td-primary table-td-primary-check"></td>
                    <td
                        v-for="item in tableList"
                        :key="item.name"
                        class="table-td-primary table-sort"
                        :class="{ 'table-td-long': item.code === 'series' }"
                    >
                        <div class="title-box">
                            <div>{{ item.name }}</div>
                            排序
                            <div class="sort-wrapp" v-if="item.sortor">
                                <Icon
                                    type="android-arrow-dropup"
                                    @click.native="sortTable(item.code, 'asc')"
                                    class="ic-btn top"
                                    :class="{
                                        act: tableParams.orderName === item.code && tableParams.orderType === 'asc',
                                    }"
                                />
                                <Icon
                                    type="android-arrow-dropdown"
                                    @click.native="sortTable(item.code, 'desc')"
                                    class="ic-btn down"
                                    :class="{
                                        act: tableParams.orderName === item.code && tableParams.orderType === 'desc',
                                    }"
                                />
                            </div>
                        </div>
                    </td>
                </tr>
            </thead>
            <tbody>
                <!-- 汇总数据 -->
                <tr class="table-tr summary">
                    <td class="table-td-primary table-td-primary-select"></td>
                    <td class="table-td-primary table-td-primary-check"></td>
                    <td
                        class="table-td-primary"
                        :class="{ 'table-td-long': item.code === 'series' }"
                        :key="item.id"
                        v-for="item in tableList"
                    >
                        <template v-if="item.code === 'id'"></template>
                        <template v-else-if="item.code === 'series'">{{ summary['name'] }}</template>
                        <template v-else>{{ summary.report ? summary.report[item.code] : '' }}</template>
                    </td>
                </tr>
                <!-- main body -->
                <tr class="table-tr" :key="index" v-for="(item, index) in originData">
                    <!-- 选择 -->
                    <td class="table-td-primary td-select">
                        <Checkbox v-model="item.selected" @on-change="onItemSelected"></Checkbox>
                    </td>
                    <!-- 开关 -->
                    <td class="table-td-primary table-td-primary-check">
                        <i-switch
                            v-if="
                                item.status == '0' ||
                                item.status == '1' ||
                                item.status == '12' ||
                                item.status == '11' ||
                                item.status == '13'
                            "
                            v-model="item.status"
                            :true-value="item.status !== 0 ? item.status : 1"
                            :false-value="0"
                            @on-change="onItemChecked(item, 'status')"
                        >
                            <span slot="open">开</span>
                            <span slot="close">关</span>
                        </i-switch>
                    </td>
                    <td
                        class="table-td-primary"
                        :class="{ 'table-td-long': tid.code === 'series' }"
                        :key="`${tid.id}${index}`"
                        v-for="tid in tableList"
                    >
                        <!-- id -->
                        <template v-if="tid.code === 'id'">{{ item.id }}</template>
                        <!-- 名称 -->
                        <template v-else-if="tid.code === 'series'">
                            <div class="flex-box">
                                <div class="flex-item">
                                    <template>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '12'"
                                            :class="`status12`"
                                            :title="statusDesc['12']"
                                        ></i>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '0'"
                                            :class="`status0`"
                                            :title="statusDesc['0']"
                                        ></i>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '1'"
                                            :class="`status1`"
                                            :title="statusDesc['1']"
                                        ></i>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '11'"
                                            :class="`status11`"
                                            :title="statusDesc['11']"
                                        ></i>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '13'"
                                            :class="`status13`"
                                            :title="statusDesc['13']"
                                        ></i>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '3'"
                                            :class="`status3`"
                                            :title="statusDesc['3']"
                                        ></i>
                                        <i
                                            class="icon status-type"
                                            v-if="item.status == '2'"
                                            :class="`status3`"
                                            :title="statusDesc['3']"
                                        ></i>
                                        <i
                                            class="icon status-type-name"
                                            v-if="item.status == '4'"
                                            :title="statusDesc[item.status]"
                                            >$</i
                                        >
                                    </template>
                                    <span
                                        v-if="item.autoCampaignType == '1'"
                                        class="icon-auto"
                                        :class="{ active: item.offerBundleStatus != '0' }"
                                        >AUTO</span
                                    >
                                    <span @click="onNext(item, item.id)" class="flex-text-title" :title="item.name">{{
                                        item.name
                                    }}</span>
                                    <span
                                        v-if="type == 'campaign'"
                                        class="tag-list"
                                        :title="item.countryType == 'white' ? item.countries : item.noncountries"
                                    >
                                        <Tag
                                            v-for="tag in item.countryTag"
                                            :color="item.countryType == 'white' ? 'blue' : 'yellow'"
                                            :key="tag"
                                            >{{ tag }}</Tag
                                        >
                                    </span>
                                    <span v-if="type == 'creative'" class="tag-list" style="flex: 0 0 auto">
                                        <Tag color="blue">{{ sizeType[item.sizeType ? item.sizeType : 1] }}</Tag>
                                    </span>
                                </div>
                                <div class="flex-item edit-btn-box">
                                    <Button type="text" class="btn-blue" @click="onchangeItem('edit', item.id)"
                                        >编辑</Button
                                    >
                                    <!-- <Button
                                        type="text"
                                        class="btn-blue"
                                        @click="onchangeItem('copy', item.id)"
                                        v-if="item.autoCampaignType != '1'"
                                        >复制</Button
                                    >
                                    <Button
                                        type="text"
                                        class="btn-blue"
                                        @click="$emit('copySeries', item.id)"
                                        v-if="item.autoCampaignType == '1' && type == 'series'"
                                        >复制</Button
                                    >
                                    <Button
                                        type="text"
                                        class="btn-blue"
                                        @click="onchangeItem('add', item.id)"
                                        v-if="
                                            (item.autoCampaignType != '1' && type != 'creative') ||
                                            (item.autoCampaignType == '1' && type == 'campaign')
                                        "
                                        >新建{{ type == 'series' ? '广告组' : '广告' }}</Button
                                    > -->
                                </div>
                            </div>
                        </template>
                        <!-- 投放状态 -->
                        <!-- <template v-else-if="tid.code === 'dropDownStatus'">
                            <span :style="{ color: item[tid.code] == 1 ? '#23c52f' : 'red' }">{{
                                { 1: '投放中', 0: '未投放' }[item[tid.code]]
                            }}</span>
                        </template> -->
                        <!-- 每日预算 -->
                        <!-- <template v-else-if="tid.code === 'dailyBudget'">
                            <div class="column-box">
                                <template v-if="item.dailyBudget">
                                    <span>花费</span>
                                    <span>${{ item.dailyBudget }}</span>
                                </template>
                                <template v-else-if="item.dailyImp">
                                    <span>展示</span>
                                    <span>{{ item.dailyImp }}千次</span>
                                </template>
                                <template v-else-if="item.dailyClick">
                                    <span>点击</span>
                                    <span>{{ item.dailyClick }}次</span>
                                </template>
                                <span v-else>不限</span>
                                <Icon @click.native="$emit('editBudget', item)" class="edit-btn" type="compose" />
                            </div>
                        </template> -->
                        <!-- 出价 -->
                        <!-- <template v-else-if="tid.code === 'bidPrice'">
                            <div class="column-box">
                                <span v-if="item.bidType == 1">CPM</span>
                                <span v-else-if="item.bidType == 2">CPA</span>
                                <span v-else-if="item.bidType == 3">CPC</span>
                                <span>${{ item.bidPrice }}</span>
                            </div>
                            <Icon @click.native="$emit('editBidprice', item)" class="edit-btn" type="compose" />
                        </template> -->
                        <!-- 缩略图 -->
                        <!-- <template v-else-if="tid.code === 'imgUrl'">
                            <img
                                v-if="item[tid.code]"
                                :src="item[tid.code].split(',')[0]"
                                alt="广告预览"
                                class="table-img cursor-pointer"
                                @click="showAdsense(item)"
                            />
                            <div v-else>No Data</div>
                        </template> -->
                        <!-- 审核状态 -->
                        <!-- <template v-else-if="tid.code === 'verifyStatus'">
                            <Poptip
                                v-if="item.verifyStatus == 2"
                                class="right"
                                trigger="hover"
                                placement="bottom-start"
                            >
                                <span class="create-status" :style="{ color: statusColor[item.verifyStatus] }">{{
                                    statusText[item.verifyStatus]
                                }}</span>
                                <div class="examine-popup-box" slot="content">
                                    <p class="examine-title">
                                        <span>拒绝原因：</span>
                                        <span>{{ item.verifyRemark }}</span>
                                    </p>
                                </div>
                            </Poptip>
                            <span v-else class="create-status" :style="{ color: statusColor[item.verifyStatus] }">{{
                                statusText[item.verifyStatus]
                            }}</span>
                        </template> -->
                        <!-- 报表数据 -->
                        <template >{{ item.report[tid.code] }}</template>
                        <!-- <template v-else>{{ item.report[tid.code] }}</template> -->
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- 表格 -->
    </div>
</template>
<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
import cPopBox from '@/components/commons/cPopBox.vue';
import cInfo from '@/components/commons/cInfo.vue';
import Vue from 'vue';
Vue.component('cInfo', cInfo);
export default {
    name: 'managementTable',
    mixins: [mixins],
    components: { cPopBox },
    props: {
        type: {
            type: String,
        },
        summary: {
            default: () => [],
        },
        originList: {
            default: () => [],
        },
        indicatorList: {
            default: () => {},
        },
        tableParams: {
            default: () => {},
        },
        tableDefaultIndicator: {
            default: () => [],
        },
    },
    watch: {
        '$store.state.manageData': {
            handler(value) {
                if (this.originData && this.originData.length > 0) {
                    let type = this.type;
                    if (type === 'creative') {
                        this.selectedAll = value.ad.selectCount === this.originData.length;
                    } else if (type === 'series') {
                        this.selectedAll = value.series.selectCount === this.originData.length;
                    } else if (type === 'campaign') {
                        this.selectedAll = value.group.selectCount === this.originData.length;
                    }
                }
            },
            deep: true,
        },
        indicatorList: {
            handler(data) {
                if ((data && data.length) || data[0]) {
                    let arr = [
                        ...data[0].filter((item) => item.selected),
                        ...data[1].filter((item) => item.selected),
                        ...data[2].filter((item) => item.selected),
                        ...data[3].filter((item) => item.selected),
                    ];
                    arr.unshift(...this.tableDefaultIndicator);
                    let filterArr = arr;
                    this.tableList = filterArr;
                }
            },
            immediate: true,
        },
        originList: {
            handler(data) {
                this.originData = data;
                if (this.originData && this.originData.length > 0) {
                    let value = this.$store.state.manageData;
                    let type = this.type;
                    if (type === 'creative') {
                        this.selectedAll = value.ad.selectCount === this.originData.length;
                    } else if (type === 'series') {
                        this.selectedAll = value.series.selectCount === this.originData.length;
                    } else if (type === 'campaign') {
                        this.selectedAll = value.group.selectCount === this.originData.length;
                    }
                }
            },
            immediate: true,
        },
    },
    mounted() {
        if (this.indicatorList) {
            let arr = [
                ...this.indicatorList[0].filter((item) => item.selected),
                ...this.indicatorList[1].filter((item) => item.selected),
                ...this.indicatorList[2].filter((item) => item.selected),
                ...this.indicatorList[3].filter((item) => item.selected),
            ];
            arr.unshift(...this.tableDefaultIndicator);
            let filterArr = arr;
            this.tableList = filterArr;
        }
    },
    data() {
        return {
            //推广列表数据
            originData: [],
            selectedAll: false,
            statusText: ['审核中', '全部通过', '全部拒绝'],
            statusColor: ['#ef9051', '#23c52f', '#fd5f65'],
            sizeType: {
                1: '300x250',
                2: '1200x628',
                3: '720x1280',
                4: '1280x720',
                5: '320x50',
                6: '320x480',
                7: '1200x627',
                8: '320x200',
                9: '1200x628',
                10: '640x360',
            },
            infoType: {
                1: 'Mrec',
                5: 'Banner',
                6: 'Interstitial',
                7: 'Native',
                8: 'Native',
            },
            statusDesc: {
                // "0,1,4,5,6": "有效推广",
                '': '全部',
                1: '进行中',
                '0,1,4': '未归档',
                12: '进行中',
                0: '已停止',
                11: '未开始',
                13: '已结束',
                4: '超预算',
                3: '已归档',
            },
            //表头
            tableList: [],
        };
    },
    computed: {},
    created() {},
    methods: {
        onNext(item) {
            let type = this.type;
            console.log(type);
            if (type === 'creative') {
                return;
            } else if (type === 'series') {
                item.selected = true;
                this.$emit('check');
                this.$router.push({ path: '/promotionManagement/campaign' });
            } else if (type === 'campaign') {
                item.selected = true;
                this.$emit('check');
                this.$router.push({ path: '/promotionManagement/creative' });
            }
        },
        /**
         * @description 表格item操作
         * @param item
         */
        onchangeItem(action, id) {
            let type = this.type;
            if (action == 'add') {
                type = type === 'series' ? 'campaign' : 'creative';
            }
            window.open(`${location.origin}/#/newPromition?type=${type}&action=${action}&id=${id}`,'_self');
        },
        /**
         * @description 表格排序
         * @param value:string 排序的索引
         */
        sortTable(code, Type) {
            // 无效排序返回
            this.tableParams.orderName = code;
            this.tableParams.orderType = Type;
            this.$emit('change');
        },
        /**
         * @desc 表格排序
         * @param {Event} event 事件
         * @param {Item} item 行对象
         * @param {String} code 属性名
         * @param {Number} index 索引
         */
        onTabelItemChange(event, item, code, index) {
            console.log(this.originData[index]);
            // item[code] = event;
            // this.originData.splice(index, 1, item);
            this.$emit('itemChange', { data: { ...item, [code]: event }, code: code });
        },
        /**
         * @description 选中所有
         */
        onSelectedAll(bool) {
            this.originData.map((item) => (item.selected = bool));
            this.$emit('check');
        },
        onItemSelected() {
            this.$emit('check');
        },
        onItemChecked(item, code) {
            this.$emit('itemChange', { data: item, code: code });
        },
        onCopy() {
            this.$Message.success({
                content: '复制成功',
                duration: 1.5,
            });
        },
        onError() {
            this.$Modal.error({
                content: '复制失败',
                duration: 1.5,
            });
        },

        /**
         * @description 计算竞得率
         */
        successRate(click, imp) {
            let param = click && imp ? (click / imp) * 100 : 0;
            return `${param.toFixed(2)}%`;
        },
        /**
         * @desc 显示广告预览
         * @param
         */
        async showAdsense({ id }) {
            const res = await this.$axios.get(this.$port.series.getDetail, { params: { id, type: 3 } });
            if (res.status != 200) {
                this.$Message.error({ content: '获取预览失败', duration: 1.5 });
                return;
            }
            const offer = res.data.offer;
            const size = this.sizeType[offer.sizeType];
            let width = ~~size.split('x')[0];
            width = width == 1200 ? 320 : width;
            this.$Modal.info({
                title: size,
                width: width + 40 > 418 ? width + 40 : 418,
                okText: '关闭',
                render: (h) => {
                    if ([2, 5].includes(offer.creativeType)) {
                        return h('cInfo', {
                            props: {
                                type: this.infoType[offer.sizeType],
                                icon: offer.iconUrl,
                                img: offer.imgUrl,
                                title: offer.title,
                                desc: offer.description,
                                name: offer.name,
                                buttonText: offer.buttonText,
                            },
                            style: { width: `${width}px`, margin: '0 auto', marginTop: '20px' },
                        });
                    } else {
                        return h('img', {
                            attrs: { src: offer.imgUrl.split(',')[0] },
                            style: { width: `${width}px`, margin: '0 auto', marginTop: '20px' },
                        });
                    }
                },
            });
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
.manage-table {
    overflow-x: auto;
    .table-td-primary {
        min-width: 0.9rem;
        &.table-td-primary-select {
            width: 0.8rem;
            min-width: 0.6 !important;
        }
    }
    .c-body-table {
        .create-status {
            margin-left: 0.1rem;
            flex: 0 0 auto;
            font-size: 0.1rem;
        }
        .column-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.5;
        }
        .table-td-primary {
            line-height: 1 !important;
            &.td-select {
                min-width: 0.6 !important;
            }
            &.table-sort {
                position: relative;
            }

            &.table-td-primary-check {
                width: 0.7rem !important;
            }
            &.table-td-long {
                padding: 0 0.1rem 0 0.2rem !important;
            }
            .edit-btn {
                font-size: 0.18rem;
                margin-left: 0.04rem;
                position: relative;
                top: 1px;
                cursor: pointer;
                display: none;
            }
            &:hover {
                .edit-btn {
                    display: inline;
                }
            }
        }
        .table-img {
            display: inline-block;
            width: auto;
            max-width: 80px;
            max-height: 46px;
        }
        .flex-box {
            display: flex;
            overflow: hidden;
            align-items: center;
            flex-direction: column;
            .flex-item {
                width: 100%;
                line-height: 0.19rem;
                margin-top: 0.05rem;
                display: flex;
                align-items: center;
                .flex-text-title {
                    max-width: 1.2rem;
                    cursor: pointer;
                    overflow: auto;
                    text-overflow: initial;
                    white-space: normal;
                    max-width: none;
                }
            }
            .edit-btn-box {
                // visibility: hidden;
                .ivu-btn {
                    padding: 0;
                    margin-right: 0.1rem;
                }
            }
            &:hover {
                .edit-btn-box {
                    visibility: visible;
                }
            }
        }
        .title-box {
            display: flex;
            align-items: center;
            justify-content: center;
            .sort-wrapp {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 6px;
                margin-left: 4px;
                .ic-btn {
                    cursor: pointer;
                    &:hover {
                        color: $impColor;
                    }
                    &.act {
                        color: $impColor;
                    }
                    &.top {
                        width: 0.12rem;
                        line-height: 10px;
                        display: block;
                    }
                    &.down {
                        width: 0.12rem;
                        line-height: 8px;
                    }
                }
            }
        }
        .table-td-long {
            .title-box {
                justify-content: flex-start;
            }
        }
        .status-type-name {
            flex: 0 0 6px;
            width: 6px;
            color: #fd5f65;
            display: block;
            margin-right: 0.05rem;

            &.status0 {
                background-color: #fd5f65;
            }
            &.status1 {
                background-color: $impColor;
            }
            &.status12 {
                background-color: $impColor;
            }
            &.status2 {
                background-color: #fd5f65;
            }
            &.status3 {
                width: 0.16rem;
                height: 0.16rem;
                flex: 0 0 0.16rem;
                margin-top: -0.07rem;
                background-position: -2.91rem -2.6rem;
                left: 0;
                background-color: #fff;
            }
            &.status4 {
                width: 8px;
                height: 13px;
                background-position: -1.51rem -1.3rem;
                margin-top: -6px;
                background-color: #fff;
            }
            &.status11 {
                background-color: #999;
            }
            &.status13 {
                border-radius: 0;
                background-color: #000;
                border-radius: 0 !important;
            }
        }
        .status-type {
            flex: 0 0 6px;
            width: 6px;
            height: 6px;
            display: block;
            border-radius: 50%;
            margin-right: 0.05rem;

            &.status0 {
                background-color: #fd5f65;
            }
            &.status1 {
                background-color: $impColor;
            }
            &.status12 {
                background-color: $impColor;
            }
            &.status2 {
                background-color: #fd5f65;
            }
            &.status3 {
                width: 0.16rem;
                height: 0.16rem;
                flex: 0 0 0.16rem;
                margin-top: -0.07rem;
                background-position: -2.91rem -2.6rem;
                left: 0;
                background-color: #fff;
            }
            &.status4 {
                width: 8px;
                height: 13px;
                background-position: -1.51rem -1.3rem;
                margin-top: -6px;
                background-color: #fff;
            }
            &.status11 {
                background-color: #999;
            }
            &.status13 {
                border-radius: 0;
                background-color: #000;
                border-radius: 0 !important;
            }
        }
        .btn-blue {
            border: none;
            box-shadow: none;
        }

        .table-td-primary:nth-of-type(1) {
            padding-right: 0;
            padding-left: 0.2rem;
        }
        //展示删除创意按钮
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/manageTable.vue